<template>
  <div class="tags-field container" @keydown.stop>
    <div class="title">简介</div>
    <textarea
      type="text"
      class="input"
      placeholder="简介可展示关于视频的更多背景信息或内容哦"
      v-model="inputValue"
      :maxlength="maxlength"
      @blur="submit()"
      @keydown.enter="submit()"
    ></textarea>
    <div class="char-count">{{inputValue.length}}/{{maxlength}}</div>
  </div>
</template>

<script>
export default {
  model: {
    prop: "value",
    event: "submit"
  },
  data() {
    return {
      inputValue: "做短视频像PPT一样简单？快挪布到“来画动画”一探究竟吧！",
      maxlength: 64
    };
  },
  methods: {
    submit() {
      if (this.value !== this.inputValue) {
        this.$emit("submit", this.inputValue);
      }
    }
  },
  props: {
    value: String
  }
};
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  padding-top: 10px;
  padding-bottom: 10px;
}
.title {
  position: absolute;
  top: 13px;
  right: calc(100% + 28px);
  min-width: 100px;
  text-align: right;
  font-size: 14px;
  color: rgba(71, 66, 97, 1);
}
.input {
  width: 528px;
  height: 94px;
  background: #f8f8fc;
  border: 1px solid #ddd9eb;
  font-size: 14px;
  resize: none;
  padding: 13px 15px;
  color: #333;
  &::placeholder {
    color: #c1c1d0;
  }
}
.char-count {
  position: absolute;
  right: 15px;
  bottom: 20px;
  font-size: 14px;
  color: #c2c2d9;
}
</style>



// WEBPACK FOOTER //
// src/components/subtitle/subtitleExport/introField.vue